'use client';

import { useState } from 'react';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { cn } from '@/lib/utils';

const navLinks = [
  { href: '#', label: 'Home' },
  { href: '#nwp-output', label: 'Model Output' },
  { href: '#precip-tracking', label: 'Tracking' },
  { href: '#executive-briefing-center', label: 'Exec Briefing' },
  { href: '#nira-dynamics', label: 'NIRA Integration' },
  { href: '#third-party-data', label: 'Third Party Data' },
];

const linkClass = (isCurrent: boolean) =>
  cn(
    'rounded-full px-4 py-2 text-sm font-medium transition-colors',
    isCurrent
      ? 'bg-primary text-primary-foreground'
      : 'text-foreground/80 hover:bg-accent hover:text-accent-foreground',
  );

export default function LandingNavMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative flex w-full items-center justify-center">
      {/* Desktop nav - hidden below 1300px */}
      <div className="hidden min-[1300px]:block">
        <nav
          role="navigation"
          className="flex items-center gap-1 rounded-full border border-border bg-background/90 px-2 py-1.5 shadow-lg"
          style={{
            backdropFilter: 'blur(12px) saturate(120%) contrast(105%)',
            WebkitBackdropFilter: 'blur(12px) saturate(120%) contrast(105%)',
          }}
        >
          {navLinks.map((link, i) => (
            <a key={link.href} href={link.href} className={linkClass(i === 0)}>
              {link.label}
            </a>
          ))}
        </nav>
      </div>

      {/* Burger toggle - only below 1300px */}
      <button
        type="button"
        className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-popover text-popover-foreground min-[1300px]:hidden"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Toggle navigation menu"
      >
        {open ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </button>

      {/* Mobile dropdown */}
      {open && (
        <nav
          role="navigation"
          className="absolute left-0 right-0 top-full mt-2 flex flex-col gap-1 rounded-2xl border border-border bg-background/95 p-3 shadow-lg min-[1300px]:hidden"
          style={{
            backdropFilter: 'blur(12px) saturate(120%) contrast(105%)',
            WebkitBackdropFilter: 'blur(12px) saturate(120%) contrast(105%)',
          }}
        >
          {navLinks.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className={linkClass(i === 0)}
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </div>
  );
}
